import React, { useRef, useState, useEffect } from 'react';
import Breadcrumbs from "~/components/Breadcrumbs/Breadcrumbs";
import Spacer from "~/components/Spacer/Spacer";
import CobuConstants from "~/helpers/cobuConstants";
import "./UploadBranchData.module.css"; 
import { useHistory } from "react-router-dom";



import { Box, Button, Typography } from '@mui/material';
import { Colors } from '~/enums/Colors';
import { uploadBranchData } from '~/services/api/branchData';
import { getLastUploadedDate } from '~/api/branchdata';

import { useFullScreenLoader } from '~/hooks/useFullScreenLoader';
import { toast } from 'react-toastify';
import { ReactComponent as FileUploadIcon } from '~/utils/images/file-upload-icon.svg';
import classes from './UploadBranchData.module.css';


const DeeplinksbyBranch = () => {
    const [selectedFile, setSelectedFile] = useState<File>();
    const [lastUploaded, setLastUploaded] = useState<string>('Loading...');
    const { loader } = useFullScreenLoader();
    const inputRef = useRef<HTMLInputElement>(null);
  
  
    const handleDragOver = (event: React.DragEvent) => {
      event.preventDefault();
      event.stopPropagation();
    };
  
    const handleDrop = (event: React.DragEvent) => {
      event.preventDefault();
      event.stopPropagation();
  
      if (event.dataTransfer.files && event.dataTransfer.files.length > 0) {
        const file = event.dataTransfer.files[0];
        if (file.name.endsWith('.csv')) {
          setSelectedFile(file);
        } else {
          toast.error('Please upload a CSV file');
        }
      }
    };
  
    const handleUpload = async () => {
      if (!selectedFile) {
        toast.error('Please select a file to upload first');
        return;
      }
  
      const formData = new FormData();
      formData.append('file', selectedFile);
  
      loader.show();
  
      try {
        await uploadBranchData(formData);
        toast.success('File uploaded successfully!');
        setSelectedFile(undefined);
      } catch (error) {
        toast.error(error instanceof Error ? error.message : 'An error occurred while uploading the file');
      } finally {
        loader.hide();
      }
    };



    useEffect(() => {
        const fetchLastUploadedDate = async () => {
            try {
                const response = await getLastUploadedDate();
                if(response){
                setLastUploaded(response.data.lastUploaded);
                } else {
                    setLastUploaded('No data available');
                }
            } catch (error) {
                console.error('Error fetching last uploaded date:', error);
                setLastUploaded('Error loading data');
            }
        };
        
        fetchLastUploadedDate();
    }, []);

    return (
        <div className="content-container">
            <Breadcrumbs />
            <Spacer height={20} />
            <h1>{CobuConstants.deeplinksbybranch.pageTitle}</h1>
            <em>Last Uploaded: {lastUploaded}</em>
            <Spacer height={20} />
            <div className="tiles-container">
                
            <div className="content-container">
      <Breadcrumbs />
      <Spacer height={20} />
      <h1>Upload Branch Data</h1>
      <Spacer height={20} />
      
      <Box sx={{ p: 3, maxWidth: 600, margin: '0 auto' }}>
        <div
          onDragOver={handleDragOver}
          onDrop={handleDrop}
          className={`flex justify-center align-center ${classes.fileUploadWrapper}`}
        >
          <FileUploadIcon />
          <p className='margin-top-32' style={{ fontSize: '18px' }}>
            {selectedFile?.name ? (
              selectedFile.name
            ) : (
              <div>
                Drop your CSV file here or{' '}
                <span
                  style={{ textDecoration: 'underline', fontSize: '18px', cursor: 'pointer' }}
                  onClick={() => inputRef.current?.click()}
                >
                  browse
                </span>
                .
              </div>
            )}
          </p>
          <input
            type='file'
            accept='.csv'
            ref={inputRef}
            className={classes.fileInput}
            onChange={(e) => {
              const file = e?.target?.files?.[0];
              if (file) {
                if (file.name.endsWith('.csv')) {
                  setSelectedFile(file);
                } else {
                  toast.error('Please upload a CSV file');
                }
              }
            }}
          />
        </div>

        <Button
          variant="contained"
          onClick={handleUpload}
          disabled={!selectedFile}
          sx={{ 
            mt: 2,
            backgroundColor: Colors.cobuDarkBlue,
            '&:hover': {
              backgroundColor: Colors.cobuDarkBlue,
            }
          }}
        >
          Upload
        </Button>
      </Box>
    </div>


            </div>
        </div>
    );
};

export default DeeplinksbyBranch;